import { freePlayActionTypes } from '@/pages/freePlay/Constants';
import { addFinishedSectionsIntoLevel } from '@/pages/freePlay/Helpers';
import { FreePlayState } from '@/pages/freePlay/types';

const initialState: FreePlayState = {
	loading: false,
	categories: [],
	category: null,
	currentLevel: null,
	finishedLevels: null,
	lockedLevels: null,
	levelProgress: null,
	infiniteLevel: false,
	showEntranceAnimation: false,
	openFinishedFirstQuestionSetSurvey: false,
};

export default function dailyGoalReducer(state = initialState, action: any) {
	const { type, payload } = action;
	const {
		categories,
		category,
		levelId,
		finishedSections,
		levelProgress,
		showEntranceAnimation,
	} = payload || {};

	switch (type) {
		case freePlayActionTypes.GET_CATEGORIES_REQUEST:
			return {
				...state,
				loading: true,
			};

		case freePlayActionTypes.GET_CATEGORIES_SUCCESS:
			return {
				...state,
				categories,
				loading: false,
			};

		case freePlayActionTypes.GET_CATEGORIES_ERROR:
			return {
				...state,
				loading: false,
			};

		case freePlayActionTypes.GET_CATEGORY_REQUEST:
			return {
				...state,
				loading: true,
			};

		case freePlayActionTypes.GET_CATEGORY_SUCCESS:
			const currentLevel = {
				...category.current_level,
				learning_path: category.current_level.learning_path.map((section: any) => ({
					...section,
					free_play_category: {
						id: category.id,
						name: category.name,
					},
				})),
			};
			return {
				...state,
				category,
				currentLevel,
				infiniteLevel: state.levelProgress ? false : category.current_level.infinite_level,
				finishedLevels: category?.finished_levels || null,
				lockedLevels: category?.locked_levels || null,
				loading: false,
			};

		case freePlayActionTypes.GET_CATEGORY_ERROR:
			return {
				...state,
				loading: false,
			};

		case freePlayActionTypes.GET_LEVEL_REQUEST:
			return {
				...state,
				loading: true,
			};
		case freePlayActionTypes.GET_LEVEL_SUCCESS:
			return {
				...state,
				finishedLevels: addFinishedSectionsIntoLevel(
					levelId,
					state.finishedLevels,
					finishedSections,
				),
				loading: false,
			};

		case freePlayActionTypes.GET_LEVEL_ERROR:
			return {
				...state,
				loading: false,
			};

		case freePlayActionTypes.RESET_CATEGORY:
			return {
				...state,
				loading: false,
				category: null,
				currentLevel: null,
				finishedLevels: null,
			};

		case freePlayActionTypes.SET_LEVEL_PROGRESS:
			return {
				...state,
				infiniteLevel: levelProgress ? false : state.currentLevel?.infinite_level,
				levelProgress,
			};

		case freePlayActionTypes.SET_SHOW_ENTRANCE_ANIMATION:
			return {
				...state,
				showEntranceAnimation,
			};

		case freePlayActionTypes.SET_OPEN_FINISHED_FIRST_QUESTION_SET_SURVEY:
			return {
				...state,
				openFinishedFirstQuestionSetSurvey: payload.open,
			};

		default:
			return state;
	}
}
